(function () {
    'use strict';

    /**
     * Lightweight fade-up scroll animation.
     * Drop-in replacement for AOS's fade-up effect.
     * Targets [data-aos="fade-up"] — no template changes needed.
     * Initial/animated CSS lives in src/sass/theme/_fade-up.scss.
     *
     * ANIMATE_ONCE = true  → element animates in once and stays (preferred).
     * ANIMATE_ONCE = false → matches AOS reverse behaviour:
     *   scroll down → element fades up into view.
     *   scroll up   → element fades down out of view (exit from bottom only).
     *   re-entering from the top while scrolling up produces no re-animation.
     */
    var ANIMATE_ONCE = false;

    function init() {
        var elements = document.querySelectorAll('[data-aos="fade-up"]');
        if (!elements.length) return;

        // Adds .aos-animate when element enters the zone 120px above the viewport
        // bottom — but only when coming from the bottom (scrolling down).
        // Entries from the top (scrolling up) are skipped so the element simply
        // reappears without re-triggering the animation.
        var enterObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;

                // rootBounds.top === 0 (top of viewport).
                // If the element's top is below that it entered from the bottom edge.
                // If the element's top is above/at 0 it re-entered from the top — skip.
                var fromBottom = entry.rootBounds
                    ? entry.boundingClientRect.top > entry.rootBounds.top
                    : entry.boundingClientRect.top > 0;

                if (!fromBottom) return;

                var delay = parseInt(entry.target.getAttribute('data-aos-delay'), 10);

                if (delay > 0) {
                    entry.target._fadeUpTimer = setTimeout(function () {
                        entry.target.classList.add('aos-animate');
                        entry.target._fadeUpTimer = null;
                    }, delay);
                } else {
                    entry.target.classList.add('aos-animate');
                }

                if (ANIMATE_ONCE) {
                    enterObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '0px 0px -120px 0px',
            threshold: 0,
        });

        // Removes .aos-animate only when the element exits from the bottom edge
        // (user is scrolling up). Elements that scroll off the top keep their
        // animated state so they don't re-animate on the way back down.
        var exitObserver = ANIMATE_ONCE ? null : new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) return;

                // top > 0 means the element has dropped below the viewport bottom.
                // top < 0 means it exited from the top — leave the class intact.
                if (entry.boundingClientRect.top <= 0) return;

                if (entry.target._fadeUpTimer) {
                    clearTimeout(entry.target._fadeUpTimer);
                    entry.target._fadeUpTimer = null;
                }

                entry.target.classList.remove('aos-animate');
            });
        }, {
            threshold: 0,
        });

        elements.forEach(function (el) {
            enterObserver.observe(el);
            if (exitObserver) exitObserver.observe(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}());
